import * as React from 'react';
import { Icon } from 'ui/common/icon';
import { FactLink } from 'app/area/case/components/fact-box/fact-link';
import { BadgeList } from 'ui/badge-list';
import { FactItemProps } from 'app/area/case/components/fact-box/types';
import { ComplexValue, ComponentProps } from 'ui/common';

interface FactItemIntegrityStatusBarrierEvalProps extends ComponentProps, FactItemProps {
  integrityStatusBarrierEval: ComplexValue<number>;
  [key: string]: any;
}

export const IntegrityStatusBarrierEvalFactItem = (props: FactItemIntegrityStatusBarrierEvalProps) => {
  const { integrityStatusBarrierEval, title, url, linkDomain, portalTarget } = props;
  const iconIntegrityStatus = integrityStatusBarrierEval && (
    <Icon url={integrityStatusBarrierEval.icon} />
  );
  const items = [{ value: undefined, tooltip: integrityStatusBarrierEval?.description }];
  if (!integrityStatusBarrierEval?.value) {
    return null;
  }
  return <FactLink id={props.componentId} classNames="fact-item" section={linkDomain} url={url} params={props.params}>
    <BadgeList
      icon={iconIntegrityStatus}
      title={title}
      valueItems={items}
      portalTarget={portalTarget}
    />
  </FactLink>;
};
